export function findTypeByIri(
  typeArr: { '@id': string; nameFr: string }[] | undefined,
  iri: string
): string {
  const found = typeArr?.find(ent => ent['@id'] === iri);
  if (!found) return '';
  return found.nameFr;
}
